/**
 * PILOT access gate for the coach dashboard.
 *
 * The dashboard ships with the analytics X-API-Key bundled into the JS
 * (REACT_APP_COACH_PERF_API_KEY). Anyone who can log into logbook-admin
 * can technically extract the key from DevTools, so for the pilot we
 * restrict who sees the dashboard surface to a hardcoded leadership
 * allowlist (owners / primary_owners / managers within the 3-gym
 * network). Non-leadership users keep their existing /users access
 * untouched.
 *
 * Replace this with a logbook-api `/v2/me` → `staff_members.role`
 * lookup when the proper auth path ships (server-side proxy + per-user
 * scoping in pike13-reporting-v3). See docs/coach-dashboard-pilot-access.md
 * for the ungating trigger.
 */

const LEADERSHIP_EMAILS: ReadonlySet<string> = new Set([
  "ray@startingstrengthgyms.com",
  "ben@startingstrengthgyms.com",
  "ben@bgilly.com", // Ben's staging identity (ss-staging Mongo); harmless in prod.
  "jen@startingstrengthgyms.com",
  "bre@startingstrengthgyms.com",
  "nick@startingstrengthgyms.com",
  "khilliard@startingstrengthgyms.com", // Kaylah Hilliard, leadership at a pilot gym (added 2026-05-22)
  "kristian.salvo@gmail.com",
  "nguyenhaidang123123@gmail.com"
]);

export function isLeadership(email?: string | null): boolean {
  if (!email) return false;
  return LEADERSHIP_EMAILS.has(email.toLowerCase());
}
